import styled from 'styled-components'

import Div from 'ui/elements/Div'

const Col = styled(Div)``

export default Col
